<template>
  <div class="files__wrapper">
    <v-chip
      v-for="file in files"
      :key="file.id"
      :href="file.url"
      color="grey lighten-3"
      class="files__item"
      target="_blank"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div class="files__select">
            <div v-if="selectable">
              <input
                @change="pushFilesToDelete({ id: file.id })"
                type="checkbox"
                :id="file.id"
              />
              <label :for="file.id" v-on="on" v-bind="attrs">
                <v-icon x-small>mdi-check</v-icon>
              </label>
            </div>
          </div>
        </template>
        <span>{{ $t('upload.select') }}</span>
      </v-tooltip>

      <strong>
        <span class="d-block text-truncate mw-300">
          {{ file.name }}
        </span>
      </strong>

      <div class="files__actions">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click.prevent="deleteFile(file)"
              :disabled="isAppointmentFilesDeleting"
              color="red"
              class="ml-3"
              icon
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('upload.exclude') }}</span>
        </v-tooltip>
      </div>
    </v-chip>
    <div class="files__component-wrapper">
      <HUploading v-if="isAppointmentFilesUploading" />

      <div class="d-block mh-5 mb-n1">
        <v-progress-linear
          v-if="isAppointmentFilesLoading"
          color="success"
          indeterminate
          absolute
        />
      </div>

      <HUpload
        @change="handleGetFiles"
        :loading="isAppointmentFilesLoading"
        :componentId="componentId"
        :small="small"
        ref="filesUpload"
        multiple
      />
    </div>

    <ModalAppointmentDeleteOneFile
      :handleDelete="deleteAppointmentFile"
      @resetSelectedFiles="resetSelectedFiles"
    />
    <ModalAppointmentDeleteAllFiles :handleDelete="deleteAppointmentFile" />
    <ModalAppointmentDeleteSelectedFiles
      :handleDelete="deleteAppointmentFile"
      @resetSelectedFiles="resetSelectedFiles"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import HUpload from '../lib/HUpload'
import HUploading from '@/components/app/HUploading'

import ModalAppointmentDeleteOneFile from './modals/ModalAppointmentDeleteOneFile'
import ModalAppointmentDeleteAllFiles from './modals/ModalAppointmentDeleteAllFiles'
import ModalAppointmentDeleteSelectedFiles from './modals/ModalAppointmentDeleteSelectedFiles'

export default {
  name: 'AppointmentFilesUpload',

  components: {
    HUpload,
    HUploading,
    ModalAppointmentDeleteOneFile,
    ModalAppointmentDeleteAllFiles,
    ModalAppointmentDeleteSelectedFiles,
  },

  props: {
    small: {
      type: Boolean,
      default: false,
    },

    selectable: {
      type: Boolean,
      default: true,
    },

    componentId: {
      type: String,
      default: 'filesUpload',
    },
  },

  data() {
    return {
      files: [],
      file: null,
    }
  },

  watch: {
    appointmentFiles: {
      handler: function (files) {
        if (files.length !== this.files.length) {
          this.files = files
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters([
      'appointmentFiles',
      'appointmentFilesToDelete',
      'isAppointmentFilesLoading',
      'isAppointmentFilesDeleting',
      'isAppointmentFilesUploading',
    ]),
  },

  methods: {
    ...mapActions([
      'openModal',
      'fetchAppointmentFiles',
      'attachAppointmentFiles',
      'deleteAppointmentFile',
    ]),

    ...mapMutations(['closeAllModals', 'setAppointmentFilesToDelete']),

    handleGetFiles(files) {
      this.attachAppointmentFiles(files)
    },

    expandFile(url) {
      this.file = url
      this.openModal('APPOINTMENT_FILE_VISUALIZATION')
    },

    deleteFile(file) {
      this.setAppointmentFilesToDelete([])

      Promise.resolve(this.setAppointmentFilesToDelete([file])).then(() => {
        this.openModal('DELETE_ONE_APPOINTMENT_FILE')
      })
    },

    pushFilesToDelete({ id }) {
      const files = this.appointmentFilesToDelete
      const index = files.indexOf(id)

      if (index >= 0) {
        files.splice(index, 1)
        this.setAppointmentFilesToDelete(files)
      } else {
        files.push(id)
        this.setAppointmentFilesToDelete(files)
      }
    },

    resetSelectedFiles() {
      const fileFieldSelected = document.querySelectorAll('.files__select input')
      fileFieldSelected.forEach((file) => (file.checked = false))
      this.setAppointmentFilesToDelete([])
    },

    resetFilesList() {
      this.files = []
      this.resetSelectedFiles()
    },
  },

  mounted() {
    this.$route?.params?.id &&
      this.fetchAppointmentFiles(this.$route?.params?.id)
  },
}
</script>
